<template>
	<div class="dashboard-wrapper">
		<v-container fluid class="pa-4">
			<!-- Panel de Filtros -->
			<v-card class="filters-card mb-6" elevation="3">
				<v-card-title>
					<v-icon left color="primary" size="32">mdi-filter-variant</v-icon>
					<span class="text-h5 font-weight-bold">Filtros</span>
				</v-card-title>
				<v-card-text>
					<v-row dense>
						<v-col cols="12" sm="6" md="3">
							<s-select-definition label="Destino" :def="1181" v-model="filtersData.Destiny"
								outlined dense clearable></s-select-definition>
						</v-col>
						<v-col cols="12" sm="6" md="3">
							<s-select-definition label="Línea Empaque" :def="1315" v-model="filtersData.Line"
								outlined dense clearable></s-select-definition>
						</v-col>
						<v-col cols="12" sm="6" md="3">
							<s-select-definition label="Turno" :def="1278" v-model="filtersData.Turn"
								outlined dense clearable></s-select-definition>
						</v-col>
						<v-col cols="12" sm="6" md="3">
							<s-date label="Fecha" v-model="filtersData.Date" outlined dense clearable></s-date>
						</v-col>
					</v-row>
					<v-row dense>
						<v-col cols="12" md="6">
							<s-select :items="presentationItems" item-value="PrcID" item-text="PresentationName"
								label="Presentación" v-model="filtersData.Presentation"
								outlined dense clearable></s-select>
						</v-col>
						<v-col cols="12" sm="6" md="3">
							<s-text type="time" label="Hora Inicio" v-model="filtersData.StartTime" outlined dense clearable></s-text>
						</v-col>
						<v-col cols="12" sm="6" md="3">
							<s-text type="time" label="Hora Fin" v-model="filtersData.EndTime" outlined dense clearable></s-text>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>

			<v-row>
				<!-- Columna de Filtros Arrastrables -->
				<v-col cols="12" md="3">
					<v-card outlined class="pa-2">
						<h3 class="text-h6 mb-3 text-center">Agrupar por (Arrastre para ordenar)</h3>
						<draggable v-model="draggableFilters" class="list-group" ghost-class="ghost">
							<transition-group type="transition" name="flip-list">
								<div v-for="element in draggableFilters" :key="element.id" class="draggable-item mb-2">
									<v-card class="pa-3 d-flex align-center justify-space-between" elevation="1">
										<div class="d-flex align-center">
											<v-icon color="grey mr-2">mdi-drag</v-icon>
											<span>{{ element.label }}</span>
										</div>
										<v-switch v-model="element.active" dense hide-details class="mt-0 pt-0"></v-switch>
									</v-card>
								</div>
							</transition-group>
						</draggable>
					</v-card>
				</v-col>

				<!-- Columna de Resultados -->
				<v-col cols="12" md="9">
					<v-card outlined>
						<v-card-title>
							Resultados Agrupados
							<v-spacer></v-spacer>
							<v-chip color="primary" outlined>Total Registros: {{ filteredData.length }}</v-chip>
						</v-card-title>
						<v-data-table :headers="dynamicHeaders" :items="groupedData" :items-per-page="15"
							class="elevation-1" dense>
							<template v-slot:item.TotalBoxes="{ item }">
								<span class="font-weight-bold primary--text">{{ item.TotalBoxes }}</span>
							</template>
						</v-data-table>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>

<script>
import draggable from "vuedraggable";

export default {
	name: "DynamicPackingFilter",
	components: {
		draggable
	},
	data() {
		return {
			filtersData: {
				Destiny: null,
				Line: null,
				Turn: null,
				Date: null,
				Presentation: null,
				StartTime: null,
				EndTime: null
			},
			draggableFilters: [
				{ id: 1, label: "Destino", fieldName: "Destiny", active: true },
				{ id: 2, label: "Línea de Producción", fieldName: "Line", active: true },
				{ id: 3, label: "Turno", fieldName: "Turn", active: true },
				{ id: 4, label: "Fecha", fieldName: "Date", active: true },
				{ id: 5, label: "Presentación", fieldName: "Presentation", active: true },
				{ id: 6, label: "Hora", fieldName: "Hour", active: true }
			],
			mockData: [],
			presentationItems: [
				{ PrcID: 1, PresentationName: "2kg" },
				{ PrcID: 2, PresentationName: "5kg" },
				{ PrcID: 3, PresentationName: "10kg" },
				{ PrcID: 4, PresentationName: "Caja Plástica" }
			]
		};
	},
	computed: {
		activeFilters() {
			return this.draggableFilters.filter(f => f.active);
		},
		dynamicHeaders() {
			const headers = this.activeFilters.map(f => ({
				text: f.label,
				value: f.fieldName,
				sortable: true
			}));
			headers.push({ text: "Total Cajas", value: "TotalBoxes", sortable: true, align: 'end' });
			return headers;
		},
		filteredData() {
			return this.mockData.filter(item => {
				// Filtro de Destino (Simulando que el filtro devuelve un ID)
				// Como es mock, asumo que si hay valor, debe coincidir. 
				// En prod, s-select-definition devuelve ID, aqui mocked strings por ahora para simpleza
				// OJO: s-select-definition devuelve un objeto o un ID dependiendo de la config.
				// Por ahora, asumiré que si se selecciona algo, filtramos "algo".
				// Para demo efectiva, voy a hacer match laxo o exacto si tengo los datos.
				
				if (this.filtersData.Destiny && item.DestinyID !== this.filtersData.Destiny) return false;
				if (this.filtersData.Line && item.LineID !== this.filtersData.Line) return false;
				if (this.filtersData.Turn && item.TurnID !== this.filtersData.Turn) return false;
				if (this.filtersData.Date && item.Date !== this.filtersData.Date) return false;
				if (this.filtersData.Presentation && item.PresentationID !== this.filtersData.Presentation) return false;
				
				if (this.filtersData.StartTime) {
					if (item.Hour < this.filtersData.StartTime) return false;
				}
				if (this.filtersData.EndTime) {
					if (item.Hour > this.filtersData.EndTime) return false;
				}

				return true;
			});
		},
		groupedData() {
			const dataToGroup = this.filteredData;
			
			if (dataToGroup.length === 0) return [];
			if (this.activeFilters.length === 0) {
				const total = dataToGroup.reduce((sum, item) => sum + item.Boxes, 0);
				return [{ TotalBoxes: total }];
			}

			const groups = {};

			dataToGroup.forEach(item => {
				const keyParts = this.activeFilters.map(f => item[f.fieldName]);
				const key = keyParts.join("|||");

				if (!groups[key]) {
					const groupObj = {};
					this.activeFilters.forEach((f, index) => {
						groupObj[f.fieldName] = keyParts[index];
					});
					groupObj.TotalBoxes = 0;
					groups[key] = groupObj;
				}

				groups[key].TotalBoxes += item.Boxes;
			});

			return Object.values(groups).sort((a, b) => b.TotalBoxes - a.TotalBoxes);
		}
	},
	created() {
		this.generateMockData();
	},
	methods: {
		generateMockData() {
			// Datos simulados con IDs para que coincidan con los posibles filtros
			const destinies = [
				{ id: 1, name: "USA" }, 
				{ id: 2, name: "EUROPA" }, 
				{ id: 3, name: "ASIA" }, 
				{ id: 4, name: "LOCAL" }
			];
			const lines = [
				{ id: 1, name: "Línea 1" }, 
				{ id: 2, name: "Línea 2" }, 
				{ id: 3, name: "Línea 3" }
			];
			const turns = [
				{ id: 1, name: "Día" }, 
				{ id: 2, name: "Noche" }
			];
			// Fechas dinamicas cercanas
			const today = new Date().toISOString().substr(0, 10);
			const dates = [today, "2026-01-10", "2026-01-11", "2026-01-12"];

			const data = [];
			for (let i = 0; i < 500; i++) {
				const destiny = destinies[Math.floor(Math.random() * destinies.length)];
				const line = lines[Math.floor(Math.random() * lines.length)];
				const turn = turns[Math.floor(Math.random() * turns.length)];
				const presentation = this.presentationItems[Math.floor(Math.random() * this.presentationItems.length)];
				const date = dates[Math.floor(Math.random() * dates.length)];
				
				const hourNum = Math.floor(Math.random() * 24);
				const hourStr = hourNum.toString().padStart(2, '0') + ":00";

				data.push({
					Destiny: destiny.name,
					DestinyID: destiny.id, // ID para filtrar
					
					Line: line.name,
					LineID: line.id,
					
					Turn: turn.name,
					TurnID: turn.id,
					
					Date: date,
					
					Presentation: presentation.PresentationName,
					PresentationID: presentation.PrcID,
					
					Hour: hourStr,
					Boxes: Math.floor(Math.random() * 50) + 1
				});
			}
			this.mockData = data;
			console.log("Mock Data Generated:", this.mockData.length, "records");
		}
	}
};
</script>

<style scoped>
.dashboard-wrapper {
	background-color: #f5f7fa;
	min-height: 100vh;
}

.draggable-item {
	cursor: move;
}

.ghost {
	opacity: 0.5;
	background: #c8ebfb;
}

.flip-list-move {
	transition: transform 0.5s;
}

.no-move {
	transition: transform 0s;
}
</style>
